import { authGet, authPost, authPost1 } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/ok99memberApi/api";

export function mbHomePageUI(queryParams) {
  return authGet(`${baseUrl}/MemberMobile1/MbHomePageUIV3`, queryParams);
}
export function mbHomePageMemberData(queryParams) {
  return authGet(`${baseUrl}/MemberMobile1/MbHomePageMemberData`, queryParams);
}

export function mbHomeBalance(queryParams) {
  return authPost(`${baseUrl}/MemberPc1/PcProfile`, queryParams);
}
export function mbHomeHistory(queryParams) {
  return authPost(`${baseUrl}/MemberMobile1/MbHomePageHistory`, queryParams);
}
